import { START_LOCATION } from 'vue-router';
import type { Router } from 'vue-router';

let hasNavigatedInApp = false;

export const trackEntryNavigation = (router: Router): void => {
  router.afterEach((_to, from) => {
    if (from !== START_LOCATION) hasNavigatedInApp = true;
  });
};

export const isDirectEntry = (): boolean => !hasNavigatedInApp;
